const footerDataEN = {
  connect: "Connect with me!",
  name: "Eleas Vrahnos",
  description1: "This website was created with React/Tailwind, with a bit of",
  description2: "cultural inspiration.",
};

const footerDataGR = {
  connect: "Συνδεθείτε μαζί μου!",
  name: "Ηλίας Βραχνός",
  description1: "Αυτή η ιστοσελίδα δημιουργήθηκε με React/Tailwind, με λίγη",
  description2: "πολιτιστική έμπνευση.",
};

export { footerDataEN, footerDataGR };
